// The "mobile app" experience — the lean, Agent-focused app (mobile router +
// Agent bottom nav). It is active when EITHER:
//   - the build target is `capacitor` (the native app is always Agent-only), or
//   - the viewport is phone-sized (the installable website/PWA shows the focused
//     Agent app to phone users, and the full management app to desktop users).
// This is why the router is chosen at runtime, not purely at build time.

export const MOBILE_APP_BREAKPOINT = 768;

const mobileMediaQuery = (): MediaQueryList =>
  globalThis.matchMedia(`(max-width: ${MOBILE_APP_BREAKPOINT - 1}px)`);

export function usesMobileApp(): boolean {
  if (__TARGET__ === "capacitor") return true;
  if (globalThis.window === undefined) return false;
  return mobileMediaQuery().matches;
}

// True only for a pointer device that can hover with a fine pointer — i.e. a
// desktop/laptop driving a mouse or trackpad. Phones and tablets report a
// coarse primary pointer and no hover. Used to tell "desktop browser shrunk
// below the breakpoint" (can widen the window) apart from "genuine mobile
// device" (cannot) — only the former should ever be told to widen its window.
export function isLikelyDesktop(): boolean {
  if (__TARGET__ === "capacitor") return false;
  if (globalThis.window === undefined) return false;
  return globalThis.matchMedia("(hover: hover) and (pointer: fine)").matches;
}

// Web/PWA only: the route tree is picked once at load (see src/router/index.ts),
// so when the viewport crosses the phone/desktop breakpoint we reload to swap
// between the lean Agent router and the full app router. Capacitor never crosses
// (it is always the Agent app), so no listener is installed there. Fires at most
// once per crossing (matchMedia "change" only fires on transition).
export function reloadOnAppModeChange(): void {
  if (__TARGET__ === "capacitor" || globalThis.window === undefined) return;
  mobileMediaQuery().addEventListener("change", () => {
    globalThis.location.reload();
  });
}
